import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingServicedeskEmployeeOnboardingConfigurationRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-employee-onboarding-configuration',
	path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent/employee-onboarding-configuration',
	exact: true,
};
